import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreateUserSnapshotRequest } from '../requests/create-user-snapshot.request';
import { CreateLicenseSnapshotRequest } from '../requests/create-license-snapshot.request';

@Injectable({
  providedIn: 'root',
})
export class IdVerificationService {
  private readonly http = inject(HttpClient);

  createUserSnapshot(
    participantId: string,
    imageBytes: string,
  ): Observable<void> {
    const request: CreateUserSnapshotRequest = {
      participantId,
      snapshotBase64Image: imageBytes,
    };
    return this.http.post<void>(`/api/participants/${participantId}/id-verification/user-snapshot`, request);
  }

  createLicenseSnapshot(
    participantId: string,
    imageBytes: string,
  ): Observable<void> {
    const request: CreateLicenseSnapshotRequest = {
      participantId,
      snapshotBase64Image: imageBytes,
    };
    return this.http.post<void>(`/api/participants/${participantId}/id-verification/license-snapshot`, request);
  }
}
